import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { api } from "../../../shared/hooks/api";
import { error, success } from "../../../utils/toast";
import BackButton from "../../../shared/components/BackButton";
import PageLoader from "../../../shared/components/LoadingPage";
import apiMethods from "../../../utils/api";
import { AddOnDetailWrapper } from "./Styled";
import Title from "./Title";
import FormContainer from "./FormContainer";
import TabNavigation from "./TabBar";

const AddOnDetail = () => {
    const { addOnId } = useParams();
    const [validated, setValidated] = useState(false);
    const [isSaving, setIsSaving] = useState(false);

    const [
        { data, isLoading, setLocalData, setLocalUrl: setGetUrl },
        fetchAddOn,
    ] = api.get(`/addons/${addOnId}/`);

    const addOnData = data;

    useEffect(() => {
        setGetUrl(`/addons/${addOnId}/`);
    }, [addOnId, setGetUrl]);

    const handleUpdate = async () => {
        if (isSaving) return;
        setIsSaving(true);
        try {
            await apiMethods.patch(`/addons/${addOnId}/`, data);
            await fetchAddOn();
            success("THÀNH CÔNG", "Cập nhật dịch vụ thành công");
        } catch (err) {
                error("Lỗi cập nhật dịch vụ", err);
        } finally {
            setIsSaving(false);
        }
    };

    return (
        <AddOnDetailWrapper>
            <BackButton route="/addons/" label="Trở Về" />
            {isLoading && <PageLoader />}

            {!isLoading && (
                <Title
                    title={addOnData.name}
                    data={addOnData}
                    setValidated={setValidated}
                    onSubmit={handleUpdate}
                    isLoading={isSaving}
                />
            )}

            {!isLoading && (
                <FormContainer
                    validated={validated}
                    addOn={addOnData}
                    mergeAddOn={(updateAddOn: any) =>
                        setLocalData({
                            ...data,
                            ...updateAddOn,
                        })
                    }
                />
            )}
        </AddOnDetailWrapper>
    );
};

export default AddOnDetail;
